export const DAY = 24 * 60 * 60 * 1000;

export function isExpired(createdAt, lifespan) {
  return createdAt < Date.now() - lifespan;
}
